<app-page-meta pageTitle="finzy - Refer & Earn"></app-page-meta>
<app-header *ngIf="finzyDomain"></app-header>
<app-theader *ngIf="otherDomain"></app-theader>
<div class="back-div">
    <a style="color: #0d3ab3;" (click)="backToPreviousPage()"> < Back </a>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="row referral-row">
            <div>
                <img
                        src="https://res.cloudinary.com/finzy/image/upload/v1508329350/group-7_qtftnh.svg"
                        style="display: block; margin: auto; max-width: 200px;"/>
                <br/>
                <div>
                    <p class="Refer-n-Earn">Refer & Earn</p>

                    <p class="Refer-n-Earn-Description">
                        You've been awesome so here is your chance to win some referral benefits. All that you need to
                        do is refer your
                        friends to finzy. They could either borrow or invest. Earn referral benefits when your friends get a
                        loan or
                        invest
                        for the first time in finzy.
                    </p>
                </div>
            </div>
            <div class="highlight">
                <h3>
                    Your Referral Code is
                </h3>
                <p class="referral-code" *ngIf="referralCode">{{referralCode}}</p>
                <mat-spinner [diameter]="35" id="spinner" class="mat-spinner" *ngIf="!referralCode"></mat-spinner>
            </div>
            <div class="referral-points">
                <p>The referral scheme is valid till
                    {{raferralDate.dateTo}}.
                </p>
            </div>
            <div style="margin-top: 20px; text-align: center">
                <p>For details on how the referral program works, please have a look at the <a routerLink="/faq"
                                                                                               target="_blank"
                                                                                               [queryParams]="{selectedTab: 'referral'}">FAQs</a>.
                </p>
            </div>
        </div>
    </div>
</div>

<app-footer *ngIf="finzyDomain"></app-footer>
<app-tfooter *ngIf="otherDomain"></app-tfooter>
